import { RedoButton } from "@redotech/redo-web/arbiter-components/buttons/redo-button";
import {
  Layout,
  RedoCheckboxCard,
} from "@redotech/redo-web/arbiter-components/checkbox/redo-checkbox-card";
import { RedoModal } from "@redotech/redo-web/arbiter-components/modal/redo-modal";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { memo, useState } from "react";

export const SelectShippingAddressModal = memo(
  function SelectShippingAddressModal({
    onSubmit,
    open,
    onClose,
    onEditOriginalAddress,
  }: {
    onSubmit: (useAutoCleanedAddress: boolean) => void;
    open: boolean;
    onClose: () => void;
    onEditOriginalAddress?: () => void;
  }) {
    const [useAutoCleanedAddress, setUseAutoCleanedAddress] = useState(true);

    return (
      <RedoModal
        additionalFooterContent={
          <RedoButton
            hierarchy="tertiary"
            onClick={onEditOriginalAddress}
            size="md"
            text="Edit original address"
          />
        }
        isOpen={open}
        modalSize="sm"
        onModalCloseRequested={onClose}
        primaryButton={{
          text: "Confirm",
          onClick: () => onSubmit(useAutoCleanedAddress),
        }}
        secondaryButton={{ text: "Cancel", onClick: onClose }}
        title="Select shipping address"
      >
        <Flex dir="column" gap="xl">
          <RedoCheckboxCard
            checked={!useAutoCleanedAddress}
            inputSize="sm"
            inputType="radio"
            layout={Layout.LEFT}
            onClick={() => {
              setUseAutoCleanedAddress(false);
            }}
            title={
              <Flex justify="space-between" w="full">
                <Text fontSize="xs" fontWeight="medium">
                  Use original address
                </Text>
              </Flex>
            }
          />
          <RedoCheckboxCard
            checked={useAutoCleanedAddress}
            inputSize="sm"
            inputType="radio"
            layout={Layout.LEFT}
            onClick={() => {
              setUseAutoCleanedAddress(true);
            }}
            title={
              <Flex justify="space-between" w="full">
                <Text fontSize="xs" fontWeight="medium">
                  Use auto cleaned address
                </Text>
              </Flex>
            }
          />
        </Flex>
      </RedoModal>
    );
  },
);
